import React from 'react';
import Chennai from '../images/Chennai.jpg'
import Hyderabad from '../images/hyderabd.jpg'
import Delhi from '../images/IndiaGateDelhi.jpg'
import Jaipur from '../images/Jaipur.jpg'
import Mumbai from '../images/mumbaisealink.jpg'
import Kota from '../images/kota.jpg'

const TopTravelledRoutesComponent = () => {
    return (
        <div className='bg-[#e7f7fe] px-5 py-8 flex flex-col justify-center items-center mt-20'>
            <p className='text-gray-600 font-bold text-2xl mb-10'>Top travelled bus routes</p>
            <div className="flex gap-2 lg:gap-8 flex-wrap items-center justify-center">
                <div className='mb-3 lg:mb-4'>
                    <img src={Chennai} className='h-40 w-96 lg:h-56 lg:w-80 rounded-lg' />
                    <p className='relative bottom-8 left-2 text-white font-semibold'>Bangalore to Chennai</p>
                </div>
                <div className='mb-3 lg:mb-4'>
                    <img src={Hyderabad} className='h-40 w-96 lg:h-56 lg:w-80 rounded-lg' />
                    <p className='relative bottom-8 left-2 text-white font-semibold'>Bangalore to Hyderabad</p>
                </div>
                <div className='mb-3 lg:mb-4'>
                    <img src={Delhi} className='h-40 w-96 lg:h-56 lg:w-80 rounded-lg' />
                    <p className='relative bottom-8 left-2 text-white font-semibold'>Jaipur to Delhi</p>
                </div>
                <div className='mb-3 lg:mb-4'>
                    <img src={Jaipur} className='h-40 w-96 lg:h-56 lg:w-80 rounded-lg' />
                    <p className='relative bottom-8 left-2 text-white font-semibold'>Delhi to Jaipur</p>
                </div>
                <div className='mb-3 lg:mb-4'>
                    <img src={Mumbai} className='h-40 w-96 lg:h-56 lg:w-80 rounded-lg' />
                    <p className='relative bottom-8 left-2 text-white font-semibold'>Bangalore to Mumbai</p>
                </div>
                <div className='mb-3 lg:mb-4'>
                    <img src={Kota} className='h-40 w-96 lg:h-56 lg:w-80 rounded-lg' />
                    <p className='relative bottom-8 left-2 text-white font-semibold'>Ahmedabad to Kota</p>
                </div>

            </div>

        </div>
    )
}

export default TopTravelledRoutesComponent
